import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.763 23.411a1.75 1.75 0 0 0 2.474 0l10.174-10.174a1.75 1.75 0 0 0 0-2.475L13.237.588a1.75 1.75 0 0 0-2.474 0L.589 10.762a1.75 1.75 0 0 0 0 2.475z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const basicShapeDiamond = { render };
export {
  basicShapeDiamond as default,
  render
};
//# sourceMappingURL=basic-shape-diamond.svg.js.map
